/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmConversationsListItems } from "../../funcs/llmConversationsListItems.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ConversationsItemsListRequest$inboundSchema,
};

export const tool$llmConversationsListItems: ToolDefinition<typeof args> = {
  name: "llm-conversations-list-items",
  description: `List conversation items

List all items for a conversation with the given ID.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmConversationsListItems(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
